<div class="page-container" *ngIf="loading === true">
  <header class="bg-default-white d-flex border-bottom">
    <app-header
      style="background-color: #edeef0"
      class="w-100 d-flex justify-content-center border"
    ></app-header>
  </header>

  <div *ngIf="clientId !== undefined"></div>
  <div class="d-flex justify-content-center mt-3 row content-size">
    <div
      class="row col-9 d-flex justify-content-center mb-5 bar-size"
      *ngIf="ispersonalstudies === 'usuarios'"
    >
      <div
        class="progress mt-4 col-4 p-0 mr-4 height-progress-bar"
        role="progressbar"
        aria-valuenow="100"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div class="progress-bar w-100 bar-color"></div>
      </div>

      <div
        class="progress mt-4 col-4 p-0 height-progress-bar"
        role="progressbar"
        aria-valuenow="0"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div
          class="progress-bar bar-color p-0"
          [class.w-0]="clientId === ''"
          [class.w-100]="clientId !== undefined"
        ></div>
      </div>

      <div
        *ngIf="clientId === undefined"
        class="col-12 d-flex justify-content-center button-top my-4 pr-4"
        (click)="redirectHome()"
      >
        <img
          src="assets/images/home-icon.png"
          class="mt-2 home-icon"
          width="18px"
          height="18px"
        />
        <a class="mt-2 ml-2 top-button">
          <div>Início</div>
        </a>
      </div>

      <div
        *ngIf="clientId !== undefined"
        class="col-12 d-flex justify-content-center button-top my-4 pr-4"
        (click)="redirectBack()"
      >
        <img
          src="assets/images/arrow-icon.png"
          class="mt-2"
          width="18px"
          height="18px"
        />
        <a class="mt-1 ml-2 top-button">
          <div>Voltar</div>
        </a>
      </div>

      <div class="d-flex justify-content-center">
        <div
          class="d-flex justify-content-center"
          *ngIf="clientId !== undefined"
        >
          <app-select-client-study
            [application]="application"
            [clientId]="clientId"
          >
          </app-select-client-study>
        </div>
        <div
          class="select-modal card rounded-3 p-3"
          *ngIf="clientId === undefined"
        >
          <div *ngIf="clientId === undefined">
            <h4
              class="border-start border-4 border-success mt-mobile ps-2 mb-4 title"
            >
              Selecione um cliente para acessar o estudo
            </h4>
            <div *ngIf="usersList">
              <div class="mb-4">
                <div class="input-group flex-nowrap border-2">
                  <span
                    class="input-group-text bg-transparent border-end-0 search-icon"
                    id="addon-wrapping"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M21.5306 20.4694L16.8365 15.7762C18.1971 14.1428 18.8755 12.0478 18.7307 9.92694C18.5859 7.80607 17.629 5.82268 16.0591 4.38935C14.4892 2.95602 12.4271 2.18311 10.3019 2.23141C8.17663 2.27971 6.15181 3.1455 4.64864 4.64867C3.14547 6.15184 2.27968 8.17666 2.23138 10.3019C2.18308 12.4272 2.95599 14.4892 4.38932 16.0591C5.82265 17.629 7.80604 18.5859 9.92691 18.7307C12.0478 18.8755 14.1428 18.1971 15.7762 16.8366L20.4693 21.5306C20.539 21.6003 20.6218 21.6556 20.7128 21.6933C20.8038 21.731 20.9014 21.7504 21 21.7504C21.0985 21.7504 21.1961 21.731 21.2871 21.6933C21.3782 21.6556 21.4609 21.6003 21.5306 21.5306C21.6003 21.4609 21.6556 21.3782 21.6933 21.2872C21.731 21.1961 21.7504 21.0985 21.7504 21C21.7504 20.9015 21.731 20.8039 21.6933 20.7128C21.6556 20.6218 21.6003 20.5391 21.5306 20.4694ZM3.74997 10.5C3.74997 9.16498 4.14585 7.85993 4.88755 6.7499C5.62925 5.63987 6.68345 4.7747 7.91686 4.26381C9.15026 3.75292 10.5075 3.61925 11.8168 3.8797C13.1262 4.14015 14.3289 4.78302 15.2729 5.72703C16.2169 6.67103 16.8598 7.87377 17.1203 9.18314C17.3807 10.4925 17.247 11.8497 16.7362 13.0831C16.2253 14.3165 15.3601 15.3707 14.2501 16.1124C13.14 16.8541 11.835 17.25 10.5 17.25C8.71037 17.248 6.99463 16.5362 5.72919 15.2708C4.46375  14.0053 3.75195 12.2896 3.74997 10.5Z"
                        fill="#43474E"
                      />
                    </svg>
                  </span>
                  <input
                    id="input_search"
                    type="text"
                    [formControl]="search"
                    class="form-control border-start-0 bg-transparent search-input"
                    placeholder="Pesquisar cliente"
                    aria-label="Pesquisar cliente"
                    aria-describedby="addon-wrapping"
                  />
                </div>
              </div>

              <div class="border rounded-4 responsive">
                <table
                  class="table table-responsive table-hover caption-top mb-0 rounded-4"
                >
                  <thead class="table-head">
                    <tr class="bg-transparent">
                      <th class="bg-transparent COLUN col-3">Cliente</th>
                      <th class="bg-transparent col-4">Última Atualização</th>
                      <th class="bg-transparent col-4">Criação</th>
                      <th class="bg-transparent col-4 py-0">
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                      </th>
                    </tr>
                  </thead>

                  <tbody class="responsive column">
                    <ng-container>
                      <tr
                        *ngFor="let item of filteredUsersList; let i = index"
                        style="cursor: pointer"
                      >
                        <td
                          class="col-4 bg-transparent"
                          (click)="openLink(item._id)"
                        >
                          <a
                            [id]="'client_name' + item._id"
                            class="text-black overflow-remove body-table-text-color text-decoration-none"
                            >{{ item.firstName }} {{ item.lastName }}</a
                          >
                        </td>
                        <td
                          class="bg-transparent col-4 body-table-text-color"
                          (click)="openLink(item._id)"
                        >
                          {{ item.updatedAt | date : "dd/MM/yyyy HH:mm" }}
                        </td>
                        <td
                          class="bg-transparent col-4 body-table-text-color"
                          (click)="openLink(item._id)"
                        >
                          {{ item.createdAt | date : "dd/MM/yyyy HH:mm" }}
                        </td>
                        <td class="p-0 bg-transparent mt-1">
                          <button
                            type="button"
                            class="btn mt-1"
                            (click)="openApplicationModal(item._id)"
                          >
                            <svg
                              _ngcontent-wfn-c77=""
                              _ngcontent-jhw-c135=""
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill=""
                            >
                              <path
                                _ngcontent-wfn-c77=""
                                _ngcontent-jhw-c135=""
                                d="M12 7.50001C11.11 7.50001 10.2399 7.76393 9.49992 8.2584C8.75989 8.75287 8.18312 9.45567 7.84252 10.2779C7.50193 11.1002 7.41282 12.005 7.58645 12.8779C7.76008 13.7508 8.18867 14.5527 8.818 15.182C9.44734 15.8113 10.2492 16.2399 11.1221 16.4135C11.995 16.5872 12.8998 16.4981 13.7221 16.1575C14.5443 15.8169 15.2471 15.2401 15.7416 14.5001C16.2361 13.7601 16.5 12.89 16.5 12C16.4987 10.8069 16.0242 9.66305 15.1806 8.8194C14.3369 7.97576 13.1931 7.50125 12 7.50001ZM12 15C11.4066 15 10.8266 14.8241 10.3333 14.4944C9.83992 14.1648 9.45541 13.6962 9.22834 13.1481C9.00128 12.5999 8.94187 11.9967 9.05763 11.4147C9.17338 10.8328 9.4591 10.2983 9.87866 9.87869C10.2982 9.45914 10.8328 9.17341 11.4147 9.05766C11.9967 8.9419 12.5999 9.00131 13.148 9.22837C13.6962 9.45544 14.1647 9.83996 14.4944 10.3333C14.824 10.8267 15 11.4067 15 12C15 12.7957 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15ZM20.25 12.2025C20.2537 12.0675 20.2537 11.9325 20.25 11.7975L21.6487 10.05C21.7221 9.95826 21.7728 9.85056 21.7969 9.7356C21.821 9.62064 21.8178 9.50162 21.7875 9.38814C21.5582 8.5262 21.2152 7.69862 20.7675 6.9272C20.7089 6.82625 20.6275 6.74037 20.5298 6.67641C20.4322 6.61245 20.3209 6.57216 20.205 6.55876L17.9812 6.31126C17.8887 6.21376 17.795 6.12001 17.7 6.03001L17.4375 3.80064C17.424 3.68459 17.3836 3.57329 17.3194 3.47563C17.2553 3.37797 17.1692 3.29665 17.0681 3.23814C16.2964 2.79128 15.4689 2.44861 14.6072 2.21907C14.4936 2.18888 14.3746 2.1858 14.2596 2.21006C14.1446 2.23432 14.037 2.28526 13.9453 2.35876L12.2025 3.75001C12.0675 3.75001 11.9325 3.75001 11.7975 3.75001L10.05 2.35407C9.95823 2.28073 9.85053 2.22997 9.73557 2.20587C9.62061 2.18177 9.50159 2.18501 9.38811 2.21532C8.52631 2.44504 7.69878 2.78803 6.92717 3.23532C6.82622 3.29394 6.74034 3.37532 6.67638 3.47297C6.61242 3.57062 6.57213 3.68186 6.55873 3.79782L6.31123 6.02532C6.21373 6.11845 6.11998 6.2122 6.02998 6.30657L3.80061 6.56251C3.68456 6.57601 3.57326 6.61644 3.4756 6.68057C3.37794 6.7447 3.29662 6.83076 3.23811 6.93189C2.79124 7.7036 2.44858 8.53111 2.21904 9.39283C2.18885 9.50638 2.18577 9.62544 2.21003 9.74041C2.23429 9.85537 2.28523 9.96303 2.35873 10.0547L3.74998 11.7975C3.74998 11.9325 3.74998 12.0675 3.74998 12.2025L2.35404 13.95C2.2807 14.0418 2.22994 14.1495 2.20584 14.2644C2.18174 14.3794 2.18498 14.4984 2.21529 14.6119C2.4446 15.4738 2.78761 16.3014 3.23529 17.0728C3.29391 17.1738 3.37529 17.2597 3.47294 17.3236C3.57059 17.3876 3.68183 17.4279 3.79779 17.4413L6.02154 17.6888C6.11467 17.7863 6.20842 17.88 6.30279 17.97L6.56248 20.1994C6.57598 20.3154 6.61641 20.4267 6.68054 20.5244C6.74467 20.6221 6.83073 20.7034 6.93186 20.7619C7.70357 21.2088 8.53108 21.5514 9.3928 21.781C9.50635 21.8111 9.62541 21.8142 9.74038 21.79C9.85534 21.7657 9.963 21.7148 10.0547 21.6413L11.7975 20.25C11.9325 20.2538 12.0675 20.2538 12.2025 20.25L13.95 21.6488C14.0417 21.7221 14.1494 21.7729 14.2644 21.797C14.3794 21.8211 14.4984 21.8178 14.6119 21.7875C15.4738 21.5582 16.3014 21.2152 17.0728 20.7675C17.1737 20.7089 17.2596 20.6275 17.3236 20.5299C17.3875 20.4322 17.4278 20.321 17.4412 20.205L17.6887 17.9813C17.7862 17.8888 17.88 17.795 17.97 17.7L20.1994 17.4375C20.3154 17.424 20.4267 17.3836 20.5244 17.3195C20.622 17.2553 20.7033 17.1693 20.7619 17.0681C21.2087 16.2964 21.5514 15.4689 21.7809 14.6072C21.8111 14.4936 21.8142 14.3746 21.7899 14.2596C21.7657 14.1447 21.7147 14.037 21.6412 13.9453L20.25 12.2025ZM18.7406 11.5931C18.7565 11.8642 18.7565 12.1359 18.7406 12.4069C18.7294 12.5924 18.7876 12.7755 18.9037 12.9206L20.234 14.5828C20.0814 15.068 19.8859 15.5386 19.65 15.9891L17.5312 16.2291C17.3467 16.2496 17.1764 16.3377 17.0531 16.4766C16.8726 16.6795 16.6804 16.8717 16.4775 17.0522C16.3387 17.1755 16.2505 17.3458 16.23 17.5303L15.9947 19.6472C15.5442 19.8833 15.0736 20.0787 14.5884 20.2313L12.9253 18.901C12.7922 18.7946 12.6269 18.7368 12.4565 18.7369H12.4115C12.1405 18.7528 11.8688 18.7528 11.5978 18.7369C11.4122 18.7257 11.2292 18.7839 11.084 18.9L9.41717 20.2313C8.93204 20.0786 8.46144 19.8832 8.01092 19.6472L7.77092 17.5313C7.75044 17.3467 7.66225 17.1764 7.52342 17.0531C7.32046 16.8727 7.12825 16.6805 6.94779 16.4775C6.82454 16.3387 6.65418 16.2505 6.46967 16.23L4.35279 15.9938C4.11672 15.5433 3.92126 15.0727 3.76873 14.5875L5.09904 12.9244C5.21521 12.7793 5.27334 12.5962 5.26217 12.4106C5.24623 12.1396 5.24623 11.8679 5.26217 11.5969C5.27334 11.4113 5.21521 11.2283 5.09904 11.0831L3.76873 9.4172C3.92138 8.93208 4.11684 8.46147 4.35279 8.01095L6.46873 7.77095C6.65325 7.75047 6.82361 7.66228 6.94686 7.52345C7.12732 7.32049 7.31952 7.12828 7.52248 6.94783C7.66187 6.82449 7.75042 6.65374 7.77092 6.46876L8.00623 4.35282C8.4567 4.11675 8.92731 3.92129 9.41248 3.76876L11.0756 5.09907C11.2207 5.21524 11.4038 5.27337 11.5894 5.2622C11.8604 5.24626 12.1321 5.24626 12.4031 5.2622C12.5887 5.27337 12.7717 5.21524 12.9169 5.09907L14.5828 3.76876C15.0679 3.92141 15.5385 4.11687 15.989 4.35282L16.229 6.46876C16.2495 6.65328 16.3377 6.82364 16.4765 6.94689C16.6795 7.12735 16.8717 7.31955 17.0522 7.52251C17.1754 7.66134 17.3458 7.74953 17.5303 7.77001L19.6472 8.00533C19.8832 8.4558 20.0787 8.92641 20.2312 9.41158L18.9009 11.0747C18.7836 11.221 18.7254 11.406 18.7378 11.5931H18.7406Z"
                                fill=""
                              ></path>
                            </svg>
                          </button>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 mb-2">
                <div class="container my-auto">
                  <nav
                    aria-label="Pagination"
                    class="row justify-content-center"
                  >
                    <ul
                      class="pagination align-items-center my-auto col-5 justify-content-center"
                    >
                      <li
                        class="page-item"
                        [ngClass]="{ disabled: currentPage === 1 }"
                      >
                        <a
                          class="btn on-hover  arrow-btn rounded-5 p-1"
                          (click)="goToPage(currentPage - 1)"
                          tabindex="0"
                          [disabled]="currentPage === 1"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.3538 16.6463C14.4002 16.6927 14.4371 16.7479 14.4622 16.8086C14.4874 16.8693 14.5003 16.9343 14.5003 17C14.5003 17.0657 14.4874 17.1308 14.4622 17.1915C14.4371 17.2521 14.4002 17.3073 14.3538 17.3538C14.3073 17.4002 14.2522 17.4371 14.1915 17.4622C14.1308 17.4873 14.0657 17.5003 14 17.5003C13.9343 17.5003 13.8693 17.4873 13.8086 17.4622C13.7479 17.4371 13.6927 17.4002 13.6463 17.3538L8.64628 12.3538C8.59979 12.3073 8.56291 12.2522 8.53775 12.1915C8.51259 12.1308 8.49963 12.0657 8.49963 12C8.49963 11.9343 8.51259 11.8692 8.53775 11.8085C8.56291 11.7478 8.59979 11.6927 8.64628 11.6463L13.6463 6.64625C13.7401 6.55243 13.8673 6.49973 14 6.49973C14.1327 6.49973 14.26 6.55243 14.3538 6.64625C14.4476 6.74007 14.5003 6.86732 14.5003 7C14.5003 7.13269 14.4476 7.25993 14.3538 7.35375L9.7069 12L14.3538 16.6463Z"
                              fill="#43474E"
                            />
                          </svg>
                        </a>
                      </li>

                      <ng-container *ngFor="let page of getPages()">
                        <li *ngIf="page !== -1" class="page-item">
                          <button
                            [ngClass]="{ 'white-text': page === currentPage }"
                            (click)="goToPage(page)"
                            [class.active]="page === currentPage"
                            class="pagination-item"
                          >
                            {{ page }}
                          </button>
                        </li>
                        <li *ngIf="page === -1" class="page-item disabled">
                          <span class="pagination-item">...</span>
                        </li>
                      </ng-container>

                      <li
                        class="page-item"
                        [ngClass]="{ disabled: currentPage === numberOfPages }"
                      >
                        <a
                          class="btn arrow-btn rounded-5 p-1"
                          (click)="goToPage(currentPage + 1)"
                          tabindex="0"
                          [disabled]="currentPage === numberOfPages"
                        >
                          <svg
                            _ngcontent-ssu-c77=""
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              _ngcontent-ssu-c77=""
                              d="M15.3538 12.3538L10.3538 17.3538C10.3073 17.4002 10.2522 17.4371 10.1915 17.4622C10.1308 17.4873 10.0657 17.5003 10 17.5003C9.93434 17.5003 9.86928 17.4873 9.80859 17.4622C9.74789 17.4371 9.69274 17.4002 9.64628 17.3538C9.59983 17.3073 9.56298 17.2521 9.53784 17.1915C9.5127 17.1308 9.49976 17.0657 9.49976 17C9.49976 16.9343 9.5127 16.8693 9.53784 16.8086C9.56298 16.7479 9.59983 16.6927 9.64628 16.6463L14.2932 12L9.64628 7.35375C9.55246 7.25993 9.49976 7.13269 9.49976 7C9.49976 6.86732 9.55246 6.74007 9.64628 6.64625C9.7401 6.55243 9.86735 6.49973 10 6.49973C10.1327 6.49973 10.26 6.55243 10.3538 6.64625L15.3538 11.6463C15.4003 11.6927 15.4372 11.7478 15.4623 11.8085C15.4875 11.8692 15.5004 11.9343 15.5004 12C15.5004 12.0657 15.4875 12.1308 15.4623 12.1915C15.4372 12.2522 15.4003 12.3073 15.3538 12.3538Z"
                              fill="#43474E"
                            ></path>
                          </svg>
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div *ngIf="usersList" class="align-items-center col-12">
                <div class="d-flex justify-content-end">
                  <a
                    id="client-study-add"
                    class="btn border border-2 border-primary signin-client-button"
                    routerLink="/estudos/usuarios/create"
                  >
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                    >
                      <g clip-path="url(#clip0_3072_30428)">
                        <path
                          d="M24.4998 12.75C24.4998 12.9489 24.4207 13.1397 24.2801 13.2803C24.1394 13.421 23.9487 13.5 23.7498 13.5H22.2498V15C22.2498 15.1989 22.1707 15.3897 22.0301 15.5303C21.8894 15.671 21.6987 15.75 21.4998 15.75C21.3008 15.75 21.1101 15.671 20.9694 15.5303C20.8288 15.3897 20.7498 15.1989 20.7498 15V13.5H19.2498C19.0508 13.5 18.8601 13.421 18.7194 13.2803C18.5788 13.1397 18.4998 12.9489 18.4998 12.75C18.4998 12.5511 18.5788 12.3603 18.7194 12.2197C18.8601 12.079 19.0508 12 19.2498 12H20.7498V10.5C20.7498 10.3011 20.8288 10.1103 20.9694 9.96967C21.1101 9.82901 21.3008 9.75 21.4998 9.75C21.6987 9.75 21.8894 9.82901 22.0301 9.96967C22.1707 10.1103 22.2498 10.3011 22.2498 10.5V12H23.7498C23.9487 12 24.1394 12.079 24.2801 12.2197C24.4207 12.3603 24.4998 12.5511 24.4998 12.75ZM19.0744 18.2672C19.2025 18.4196 19.2648 18.6166 19.2475 18.815C19.2303 19.0133 19.135 19.1966 18.9826 19.3247C18.8302 19.4527 18.6331 19.515 18.4348 19.4978C18.2365 19.4805 18.0531 19.3852 17.9251 19.2328C16.0388 16.9866 13.4457 15.75 10.6248 15.75C7.80382 15.75 5.21069 16.9866 3.32444 19.2328C3.19639 19.3851 3.01309 19.4803 2.81486 19.4974C2.61663 19.5146 2.41971 19.4523 2.26741 19.3242C2.11512 19.1962 2.01993 19.0129 2.00279 18.8146C1.98565 18.6164 2.04796 18.4195 2.17601 18.2672C3.57663 16.6003 5.31851 15.4162 7.25444 14.7825C6.07873 14.0502 5.17349 12.9549 4.67569 11.6624C4.17789 10.3698 4.11461 8.95028 4.49543 7.61855C4.87624 6.28681 5.68043 5.11534 6.78632 4.28135C7.89222 3.44736 9.23964 2.99625 10.6248 2.99625C12.0099 2.99625 13.3573 3.44736 14.4632 4.28135C15.5691 5.11534 16.3733 6.28681 16.7541 7.61855C17.1349 8.95028 17.0716 10.3698 16.5738 11.6624C16.076 12.9549 15.1708 14.0502 13.9951 14.7825C15.931 15.4162 17.6729 16.6003 19.0744 18.2672ZM10.6248 14.25C11.5889 14.25 12.5315 13.9641 13.3332 13.4284C14.1349 12.8927 14.7597 12.1314 15.1287 11.2406C15.4976 10.3498 15.5942 9.36959 15.4061 8.42393C15.218 7.47827 14.7537 6.60963 14.0719 5.92785C13.3901 5.24607 12.5215 4.78177 11.5758 4.59367C10.6302 4.40556 9.64996 4.50211 8.75917 4.87108C7.86838 5.24006 7.10701 5.8649 6.57134 6.66659C6.03567 7.46828 5.74976 8.41081 5.74976 9.375C5.75124 10.6675 6.26534 11.9066 7.17925 12.8205C8.09317 13.7344 9.33228 14.2485 10.6248 14.25Z"
                          fill="currentColor"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_3072_30428">
                          <rect
                            width="24"
                            height="24"
                            fill="white"
                            transform="translate(0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    <span class="ml-1 fw-semibold ms-2 button-new-client"
                      >Cadastrar Novo Cliente</span
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="my-2"></div>
      </div>
    </div>

    <div
      class="row col-9 d-flex justify-content-center mb-5 bar-size"
      *ngIf="ispersonalstudies === 'estudos-pessoais'"
    >
      <div
        class="col-12 d-flex justify-content-center button-top mt-3 mb-1 pr-4"
        (click)="redirectHome()"
      >
        <img src="assets/images/home-icon.png" class="mb-3" width="24px" />
        <a class="mt-1 ml-2 top-button">
          <div>Início</div>
        </a>
      </div>
      <div class="">
        <div
          class="d-flex justify-content-center"
          *ngIf="adminId !== undefined"
        >
          <app-select-client-study
            [application]="application"
            [adminId]="adminId"
          >
          </app-select-client-study>
        </div>

        <div class="my-2"></div>
      </div>
    </div>
  </div>
  <footer class="footer my-0 py-1 bg-default-white border-top mt-auto">
    <app-footer class="content-container"></app-footer>
  </footer>
</div>
